import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { default as CTAComponent } from "../cta/cta";
import { Button as LoftButton } from "@xometry/xometry_loft";
import CTA from "../cta/cta";

export const HeroBackground = styled.div`
  position: relative;
  background-color: ${theme.colors.darkBlues[100]};
  overflow: hidden;

  ${theme.largerThan["2xl"]} {
    min-height: 500px;
  }
`;

export const HeroBackgroundPoster = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const HeroBackgroundVideo = styled.video`
  position: absolute;
  width: 400%;
  max-width: none;
  top: -20%;
  left: -250%;

  ${theme.largerThan.lg} {
    left: -10%;
    top: -20%;
    width: 120%;
  }

  ${theme.largerThan["2xl"]} {
    left: -1%;
    top: -20%;
    width: 102%;
  }
`;

export const HeroBackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(9, 44, 71, 0.9);
  background: linear-gradient(
    180deg,
    rgba(9, 44, 71, 0.9) 80%,
    rgba(9, 44, 71, 1) 100%
  );
`;

export const HeroContentWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 2rem 0;
  max-width: ${theme.maxWidth};

  ${theme.largerThan.xl} {
    padding: 4rem 0;
  }
`;

export const HeroText = styled.div`
  color: #fff;

  ${theme.largerThan.lg} {
    width: 50%;
  }
`;

export const HeroTitle = styled.h1`
  color: #fff;
`;

export const HeroDescription = styled.div`
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.leading.normal};
  color: ${theme.colors.white};

  .intro {
    color: ${theme.colors.white};
  }
`;

export const Button = styled(CTAComponent)<{}>`
  padding: 12px 28px;
`;

export const FormComponent = styled.div`
  min-height: 400px;

  ${theme.largerThan["2xl"]} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
    display: grid;
    align-content: center;
  }
`;

export const StyledCTA = styled(CTA)`
  margin-left: auto;
  margin-right: auto;
`;
